import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/img-loader/img-loader';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Bem/site/faq-accordion/faq-accordion';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';

const cSliderOn = 'owl-carousel';

$('.corp-sales__slider-box').trigger('destroy.owl.carousel')
    .removeClass(cSliderOn)
    .addClass(cSliderOn)
    .owlCarousel({
        loop: true,
        dots: true,
        nav: false,
        margin: 0,
        navText: ['', ''],
        items: 1,
        slideBy: 1,
        responsive: {
            992: {
                nav: true,
                navClass: [
                    `corp-sales__arrow-prev arrow arrow_prev arrow_shadow`,
                    `corp-sales__arrow-next arrow arrow_next arrow_shadow`,
                ],
            },
        },
    });

if (getW() > eksmoBP.smMax) {
    $('.corp-sales__review-box').trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            dots: false,
            nav: true,
            items: 3,
            slideBy: 3,
            margin: 20,
            autoHeight: true,
            navText: ['', ''],
            navClass: ['corp-sales__arrow-prev arrow arrow_prev arrow_shadow', 'corp-sales__arrow-next arrow arrow_next arrow_shadow'],
        });
}

svgSpriteLoader('/landing/corp-sales/svg/sprite.svg?v=20180320');